module.exports = __webpack_public_path__ + "img/fachadaalex1.ea690cb5.png";